import api from './api';

const WalletService = {
  async getWallet() {
    const { data } = await api.get('/wallet');
    return data.data;
  },

  async getTransactions(params = {}) {
    const { data } = await api.get('/wallet/transactions', { params });
    return { data: data.data, meta: data.meta };
  },

  async getMilestone() {
    const { data } = await api.get('/wallet/milestone');
    return data.data;
  },

  async creditWelcomeBonus(email) {
    const { data } = await api.post('/wallet/bonus', { email });
    return data.data;
  },
};

export default WalletService;
